// extracted by mini-css-extract-plugin
export const contact_means_call = "PreferCall-module--contact_means_call--25YFQ";
export const form_img_container = "PreferCall-module--form_img_container--1R6p1";
export const follow_us = "PreferCall-module--follow_us--2MkvL";
export const bouncy = "PreferCall-module--bouncy--10X6u";
export const social_container = "PreferCall-module--social_container--2xpPe";